<div class="air-details-container">
    <div class="section-title">
       	Invalid Division/Section/Plant
    </div>
<div class="no-data-found">
    No Data Found
</div>
</div>